import React, { Component, Fragment } from 'react'
import StatusPageMixin from 'containers/shared/StatusPageMixin'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import StyleSheet from 'styles'
import {FormattedMessage} from 'react-intl'

export class RegistrationComplete extends StatusPageMixin(Component){
  get accountType() {
    return this.props.match.params.accountType
  }

  body = () =>
    <Fragment>
      <Typography variant='h6'><FormattedMessage id="account.registration_complete.title" /></Typography>
      <Typography variant='body2'>
        <i><FormattedMessage id="account.registration_complete.visibility_note" /></i>
      </Typography>
      {this.accountType === 'investor' &&
        <Typography variant='body2'>
          <FormattedMessage id="account.registration_complete.investor_kyc" />
        </Typography>
      }
      {this.accountType === 'issuer' &&
        <Typography variant='body2'>
          <FormattedMessage id="account.registration_complete.issuer_kyc" />
        </Typography>
      }
      <div className={styles.buttonBar}>
        <Button fullWidth variant='contained' color="secondary" onClick={() => this.props.history.push(`/${this.accountType}/${this.props.currentUser.id}/edit`)}>
          <FormattedMessage id="account.registration_complete.actions.kyc" />
        </Button>
      </div>
    </Fragment>
}

const styles = StyleSheet({
  buttonBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: [0 -5],
    '& button': {
      margin: [0, 5]
    }
  }
})
export default connect(({tokens}) => tokens)(RegistrationComplete)